export default __webpack_public_path__ + "static/media/responsive-design.6120868e.svg";